<ngx-spinner bdColor="rgba(19, 41, 61, 0.8)" ></ngx-spinner>
<router-outlet></router-outlet>